import { AppChakraProvider } from "app/provider/AppChakraProvider";
import { LoadingState } from "shared/components/empty/LoadingState";
import Page from "shared/components/layout/Page";
import PageBody from "shared/components/layout/PageBody";
import PageContainer from "shared/components/layout/PageContainer";
import PageContent from "shared/components/layout/PageContent";
import PageNav from "shared/components/layout/PageNav";
import Logo from "shared/img/logo.svg?react";

export const IndexLoading = () => (
  <AppChakraProvider>
    <Page>
      <PageNav position="absolute" right={0} left={0}>
        <Logo />
      </PageNav>
      <PageContainer>
        <PageContent isFullHeight={true}>
          <PageBody>
            <LoadingState />
          </PageBody>
        </PageContent>
      </PageContainer>
    </Page>
  </AppChakraProvider>
);
